import middleware from './middleware';
import reducers from './reducers';
import actions from './actions';
import selectors from './selectors';
import operations from './operations';

export default {
  middleware,
  actions,
  reducers,
  selectors,
  operations,
};
